import Service from '../Service'
import AuthService from '../AuthService'

const FormRO = {
    saveRO02(data) {
        return AuthService.post('/api/ro-02', data).then(res => res)
    },
    saveRO03_1(data) {
        return AuthService.post('/api/ro-03-1', data).then(res => res)
    },
    saveRO04_1(data) {
        return AuthService.post('/api/ro-04-1', data).then(res => res)
    },
    saveRO04_2(data) {
        return AuthService.post('/api/ro-04-2', data).then(res => res)
    },
    saveRO05(data) {
        return AuthService.post('/api/ro-05', data).then(res => res)
    },
    saveDraftRO05(data) {
        return AuthService.post('/api/ro-05-draft', data).then(res => res)
    },
    saveRO06_1(data) {
        return AuthService.post('/api/ro-06-1', data).then(res => res)
    },
    saveDraftRO06_1(data) {
        return AuthService.post('/api/ro-06-1-draft', data).then(res => res)
    },
    saveRO07_1(data) {
        return AuthService.post('/api/ro-07-1', data).then(res => res)
    },
    saveDraftRO07_1(data) {
        return AuthService.post('/api/ro-07-1-draft', data).then(res => res)
    },
    saveRO08(data) {
        return AuthService.post('/api/ro-08', data).then(res => res)
    },
    saveDraftRO08(data) {
        return AuthService.post('/api/ro-08-draft', data).then(res => res)
    },
    saveRO09(data) {
        return AuthService.post('/api/ro-09', data).then(res => res)
    },
    saveDraftRO09(data) {
        return AuthService.post('/api/ro-09-draft', data).then(res => res)
    },
    saveRO10(data) {
        return AuthService.post('/api/ro-10', data).then(res => res)
    },
    saveDraftRO10(data) {
        return AuthService.post('/api/ro-10-draft', data).then(res => res)
    },
    saveRO19(data) {
        return AuthService.post('/api/ro-19', data).then(res => res)
    },
    saveDraftRO19(data) {
        return AuthService.post('/api/ro-19-draft', data).then(res => res)
    },
    getRO02(id) {
        return AuthService.get(`/api/ro-02/${id}`).then(res => res)
    },
    getRO03_1(data) {
        return AuthService.get(`/api/ro-03-1/${data.researchID}?order=${data.order}`).then(res => res)
    },
    getRO04_1(id) {
        return AuthService.get(`/api/ro-04-1/${id}`).then(res => res)
    },
    getRO04_2(id) {
        return AuthService.get(`/api/ro-04-2/${id}`).then(res => res)
    },
    getRO05(data) {
        return AuthService.get(`/api/ro-05/${data.researchID}?rfID=${data.rfID}`).then(res => res)
    },
    getRO06_1(id) {
        return AuthService.get(`/api/ro-06-1/${id}`).then(res => res)
    },
    getRO07_1(data) {
        return AuthService.get(`/api/ro-07-1?rfID=${data.rfID}&rfType=${data.rfType}&id=${data.id}`,).then(res => res)
    },
    getRO08(id) {
        return AuthService.get(`/api/ro-08/${id}`).then(res => res)
    },
    getRO09(id) {
        return AuthService.get(`/api/ro-09/${id}`).then(res => res)
    },
    getRO10(id) {
        return AuthService.get(`/api/ro-10/${id}`).then(res => res)
    },
    getRO19(id) {
        return AuthService.get(`/api/ro-19/${id.rfID}`).then(res => res)
    },
    getROSusar(data) {
        return AuthService.get(`/api/ro-susar/${data.researchID}?rfID=${data.rfID}`).then(res => res)
    },
    saveROSusar(data) {
        return Service.post('/api/rosusar-save', data).then(res => res)
    },
    saveDraftROSusar(data) {
        return Service.post('/api/rosusar-draft', data).then(res => res)
    },
    uploadpdf(data) {
        return Service.post('/api/upload-pdf', data).then(res => res)
    }
}

export default FormRO;
